<ng-template #tplLink let-item="item">
  <a [link]="item" uiNavLink>{{ item.label }}</a>
</ng-template>

<ng-template #tplButton let-item="item">
  <div class="footer-button">
    <h3>{{ item.headlines.headline }}</h3>

    @if (item.headlines.subline) {
      <p>{{ item.headlines.subline }}</p>
    }

    <a class="footer-button-link" [link]="item.button.link" uiContentLink mat-stroked-button>
      {{ item.button.link.label }}
    </a>

  </div>
</ng-template>

<ng-template #tplNav let-column="column">
  <nav class="footer-navigation-col">
    @if (column.title) {
      <h3>
        @if (column.icon) {
          <ui-icon [faName]="column.icon.name" [faStyle]="column.icon.family" [title]="column.title" />
        }
        {{ column.title }}
      </h3>
    }

    @if (column.description) {
      <h4>
        {{ column.description }}
      </h4>
    }

    @for (item of column.items; track item) {
      @let template = item.type === 'cta_bar' ? tplButton : tplLink;
      @let ctx = { item };

      <ng-container *ngTemplateOutlet="template; context: ctx"></ng-container>
    }
  </nav>
</ng-template>

<footer>
  <div class="footer-navigation">
    @for (column of data().columns; track column) {
      <ng-container
        *ngTemplateOutlet="tplNav; context: { column }">
      </ng-container>
    }
  </div>

  @if (legalNav()?.children; as legalItems) {
    <div class="sub-footer">
      <nav class="legal-pages">
        <ul>
          @for (item of legalItems; track item) {
            <li>
              <a [link]="item" uiNavLink>{{ item.label }}</a>
            </li>
          }
        </ul>
      </nav>
    </div>
  }

  <div class="copyright-wrapper">
    <p class="copyright-note">{{ copyrightText() }}</p>
  </div>
</footer>
